module.exports = __webpack_public_path__ + "img/eye_contour.d71d5166.svg";